import { Filter } from '../models/filter.model';
import { FilterOption } from '../interfaces/filteroption.interface';
import { SingleValueFilterOption } from '../models/singlevaluefilteroption.model';
import { RangeFilterOption } from '../models/rangefilteroption.model';
import { Injectable } from '@angular/core';

@Injectable()
export class StateHelper {
  createFiltersForState(filters: Filter[]): Filter[] {
    return filters.map((filter: Filter) => {
      const optionsCopy: FilterOption[] = filter.options.map(
        (option: FilterOption) => {
          let result: FilterOption;
          switch (option.type) {
            case SingleValueFilterOption.TYPE:
              result = Object.assign(new SingleValueFilterOption(), option);
              break;
            case RangeFilterOption.TYPE:
              result = Object.assign(new RangeFilterOption(), option);
              break;
            default:
              throw new Error(`Unsupported type ${option.type}`);
          }
          return result;
        },
      );
      return Object.assign(new Filter(), filter, { options: optionsCopy });
    });
  }

  createFiltersFromStateObject(stateObject: Filter[]): Filter[] {
    return stateObject.map((filter: Filter) => {
      let filterCopy: Filter = new Filter();
      filterCopy = <Filter>Object.assign(filterCopy, filter);
      filterCopy.options = filter.options.map((option: FilterOption) => {
        let result: FilterOption;
        switch (option.type) {
          case SingleValueFilterOption.TYPE:
            result = Object.assign(new SingleValueFilterOption(), option);
            break;
          case RangeFilterOption.TYPE:
            result = Object.assign(new RangeFilterOption(), option);
            break;
          default:
            throw new Error(`Unsupported type ${option.type}`);
        }
        return result;
      });
      return filterCopy;
    });
  }
}
